import { AxiosResponse } from 'axios';
import { Auth } from 'aws-amplify';
import { RestService } from '@kasasa/kloans-common-ui/src/consumer-app/services/rest/index';
import {
	EnvironmentData,
	SsoAuthenticationData,
} from '@/login/clients/types/Authentication';
import {
	SuccessEnvelope,
} from '@kasasa/kloans-common-ui/src/consumer-app/services/rest/types/index';

const restService = new RestService();

const getEnvironmentData = async (): Promise<EnvironmentData> => {
	const response: AxiosResponse<SuccessEnvelope<EnvironmentData>> = await restService.http.get(
		'/api/cognito/environment',
	);

	return response.data.data;
};

const ssoAuthenticate = (authData: SsoAuthenticationData): void => {
	Auth.configure(
		{
			region: authData.region,
			userPoolId: authData.userPoolId,
			userPoolWebClientId: authData.clientId,
			oauth: {
				domain: authData.domain,
				scope: ['phone', 'email', 'openid'],
				redirectSignIn: `${authData.redirectUri}/profile`,
				redirectSignOut: `${authData.redirectUri}/login`,
				responseType: 'code',
			},
		},
	);
};

export {
	getEnvironmentData,
	ssoAuthenticate,
};
